import { render, staticRenderFns } from "./ScreenThree.vue?vue&type=template&id=19f1255a&"
import script from "./ScreenThree.vue?vue&type=script&lang=js&"
export * from "./ScreenThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports